import React from 'react';
import Container from 'react-bootstrap/Container';

export const Layout =(props:any) => (
    <div>
    <Container>
        {props.children}
    </Container>
    </div>
)
